var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--gis",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.782 55.36c5.513.635 10.687-1.049 14.638-4.763c4.012-3.771 5.817-7.914 5.817-13.354c0-5.508-1.823-9.633-5.955-13.478c-1.826-1.7-4.227-3.095-6.844-3.978c-2.14-.723-6.883-.903-9.427-.358c-2.833.606-6.203 2.365-8.336 4.349c-3.99 3.712-5.901 8.075-5.901 13.465c0 3.231.472 5.255 1.915 8.206c1.05 2.147 1.444 2.682 3.406 4.633c1.708 1.699 2.645 2.425 4.074 3.159c2.355 1.208 4.406 1.865 6.613 2.12zm1.036 44.214c-.388-.236-2.127-1.926-3.865-3.756C31.64 81.798 22.345 68.161 17.3 55.241c-1.518-3.887-2.08-5.85-2.675-9.33c-1.823-10.67.36-21.094 6.272-29.96c2.25-3.375 6.816-7.95 10.075-10.098c11.891-7.835 26.22-7.802 38.166.087c3.1 2.048 7.711 6.702 9.906 10c4.018 6.039 6.16 12.237 6.81 19.715c.531 6.102-.383 12.06-2.862 18.694c-4.826 12.902-13.598 25.78-28.706 42.144c-3.373 3.653-3.971 3.99-5.468 3.08z",
    fill: "#ff0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoi);
export default __webpack_public_path__ + "static/media/poi.7bc4349c09878832b2b2139f0d15c29b.svg";
export { ForwardRef as ReactComponent };